function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
import { GridColumnMenuItem } from './GridColumnMenuItem';
import { GridColumnMenuItemGroup } from './GridColumnMenuItemGroup';
import { normalize } from '../interfaces/GridSortSettings';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, sortAscending, sortDescending } from '../messages';
/**
 * @hidden
 */

var ASC_DIR = 'asc';
/**
 * @hidden
 */

var DESC_DIR = 'desc';
/**
 * @hidden
 */

var sortSeqMap = {
  true: {
    'asc': {
      'asc': '',
      'desc': 'desc'
    },
    'desc': {
      'asc': 'asc',
      'desc': ''
    },
    '': {
      'asc': 'asc',
      'desc': 'desc'
    }
  },
  false: {
    'asc': {
      'asc': 'asc',
      'desc': 'desc'
    },
    'desc': {
      'asc': 'asc',
      'desc': 'desc'
    },
    '': {
      'asc': 'asc',
      'desc': 'desc'
    }
  }
};
/**
 * @hidden
 */

var sortIndex = function sortIndex(field, sort) {
  if (!sort) {
    return -1;
  }

  return sort.findIndex(function (s) {
    return s.field === field;
  });
};
/**
 * @hidden
 */


var sortedAsc = function sortedAsc(sortedIndex, sort) {
  return !!(sort && sortedIndex > -1 && sort[sortedIndex].dir === ASC_DIR);
};
/**
 * @hidden
 */


var sortedDesc = function sortedDesc(sortedIndex, sort) {
  return !!(sort && sortedIndex > -1 && sort[sortedIndex].dir === DESC_DIR);
}; // tslint:disable:max-line-length

/**
 * Can be used to check if sorting is applied to a specific field ([see example]({% slug column_menu_grid %}#toc-styling-the-column-menu-icon)). Useful for creating active sort indicators.
 */
// tslint:enable:max-line-length


export var sortGroupByField = function sortGroupByField(field, sort) {
  var currentSortIndex = sortIndex(field, sort);
  return sortedDesc(currentSortIndex, sort) || sortedAsc(currentSortIndex, sort);
};
/**
 * @example
 *  {% meta height:410 %}
 *  ```html-preview
 *  <div id="vueapp">
 *     <Grid :style="{height: '280px'}"
 *          :data-items="gridData"
 *          :sortable="true"
 *          :sort= "sort"
 *          :filter="filter"
 *          :expand-field="'Discontinued'"
 *          @dataStateChange="dataStateChange"
 *          @expandchange="expandChange"
 *          :columns="columns">
 *       </Grid>
 *  </div>
 * ```
 * ```js
 * import { Grid, GridColumnMenuSort } from '@progress/kendo-vue-grid';
 * import { process } from '@progress/kendo-data-query';
 *      const ColumnMenu = {
 *        props: {
 *            column: Object,
 *            sortable: [Boolean, Object],
 *            sort: {
 *                type: Array
 *            },
 *            filter: Object,
 *            filterable: Boolean
 *        },
 *        components: {
 *            GridColumnMenuSort
 *        },
 *        template: `<div>
 *            <GridColumnMenuSort
 *                :column="column"
 *                :filterable="filterable"
 *                :filter="filter"
 *                @closemenu ="closeMenu"
 *                @sortchange = "sortChange"
 *            />
 *        </div>`,
 *        methods: {
 *            closeMenu () {
 *                this.$emit('closemenu');
 *            },
 *            sortChange (newDescriptor, e) {
 *                this.$emit('filterchange', newDescriptor, e);
 *            }
 *        }
 *      };
 *
 *      Vue.component('Grid', Grid);
 *      new Vue({
 *          el: '#vueapp',
 *          components: {
 *            Grid
 *          },
 *          created: function() {
 *             this.getData();
 *          },
 *          methods: {
 *            getData: function () {
 *                let dataState = {
 *                    filter: this.filter,
 *                    sort: this.sort
 *                };
 *                this.gridData = process([{
 *                    "ProductID": 1,
 *                    "ProductName": "Chai",
 *                    "UnitsInStock": 39,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 8, 20)
 *                },{
 *                    "ProductID": 2,
 *                    "ProductName": "Chang",
 *                    "UnitsInStock": 17,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 7, 12)
 *                },{
 *                    "ProductID": 3,
 *                    "ProductName": "Aniseed Syrup",
 *                    "UnitsInStock": 13,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 8, 26)
 *                },{
 *                    "ProductID": 4,
 *                    "ProductName": "Chef Anton's Cajun Seasoning",
 *                    "UnitsInStock": 53,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 9, 19)
 *                }], dataState);
 *            },
 *            createAppState: function(dataState) {
 *                this.sort = dataState.sort;
 *                this.filter = dataState.filter;
 *                this.getData();
 *            },
 *            dataStateChange: function (event) {
 *                this.createAppState(event.data);
 *            },
 *            expandChange: function (event) {
 *                Vue.set(event.dataItem, event.target.$props.expandField, event.value);
 *            }
 *          },
 *          data: function () {
 *              return {
 *                 filter: null,
 *                 sort: [],
 *                  gridData: [],
 *                  columns: [
 *                      { field: 'ProductID'},
 *                      { field: 'ProductName', title: 'Product Name' },
 *                      { field: 'UnitsInStock', title: 'Units In Stock', columnMenu: ColumnMenu }
 *                  ]
 *              };
 *          }
 *       } );
 * ```
 */

var GridColumnMenuSort =
/** @class */
function (_super) {
  __extends(GridColumnMenuSort, _super);

  function GridColumnMenuSort() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */


  GridColumnMenuSort.prototype.onAscClick = function (e) {
    this.onSort(e, ASC_DIR);
    this.$emit('closemenu');
  };
  /**
   * @hidden
   */


  GridColumnMenuSort.prototype.onDescClick = function (e) {
    this.onSort(e, DESC_DIR);
    this.$emit('closemenu');
  };
  /**
   * @hidden
   */


  GridColumnMenuSort.prototype.onSort = function (e, selectedDir) {
    e.preventDefault();

    if (!this.$listeners.sortchange) {
      return;
    }

    var _a = this.$props,
        column = _a.column,
        sortable = _a.sortable,
        sort = _a.sort;

    var _b = normalize(sortable || false, false),
        allowUnsort = _b.allowUnsort,
        mode = _b.mode;

    var oldDescriptor = (sort || []).filter(function (d) {
      return d.field === column.field;
    })[0];
    var dir = sortSeqMap[allowUnsort][oldDescriptor && oldDescriptor.dir || ''][selectedDir];
    var newDescriptor = mode === 'single' ? [] : (this.$props.sort || []).filter(function (d) {
      return d.field !== column.field;
    });

    if (dir !== '' && column.field) {
      newDescriptor.push({
        field: column.field,
        dir: dir
      });
    }

    this.$emit('sortchange', newDescriptor, {
      event: e,
      field: this.$props.column.field
    });
  };
  /**
   * @hidden
   */
  // @ts-ignore


  GridColumnMenuSort.prototype.render = function (h) {
    var _a = this.$props,
        sort = _a.sort,
        column = _a.column;
    var currentSortIndex = sortIndex(column.field, sort);
    var localizationService = provideLocalizationService(this);
    return h(GridColumnMenuItemGroup, [h(GridColumnMenuItem, {
      attrs: {
        title: localizationService.toLanguageString(sortAscending, messages[sortAscending]),
        iconClass: 'k-i-sort-asc-sm',
        selected: sortedAsc(currentSortIndex, sort)
      },
      on: {
        "click": this.onAscClick
      }
    }), h(GridColumnMenuItem, {
      attrs: {
        title: localizationService.toLanguageString(sortDescending, messages[sortDescending]),
        iconClass: 'k-i-sort-desc-sm',
        selected: sortedDesc(currentSortIndex, sort)
      },
      on: {
        "click": this.onDescClick
      }
    })]);
  };

  GridColumnMenuSort = __decorate([Component({
    props: {
      sortable: [Boolean, Object],
      sort: {
        type: Array
      },
      column: Object
    },
    inject: {
      kendoLocalizationService: {
        default: null
      }
    }
  })], GridColumnMenuSort);
  return GridColumnMenuSort;
}(VueComponent);

export { GridColumnMenuSort };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/columnMenu/GridColumnMenuSort.js
// module id = null
// module chunks = 